var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { BaseInput } from '../ui';
export var RangeFilter = function (_a) {
    var filter = _a.filter, filters = _a.filters, setFilters = _a.setFilters;
    var minValue = useMemo(function () {
        var _a;
        return (((_a = filters.appliedFilters.find(function (f) { return f.queryKey === filter.queryName.split(',')[0]; })) === null || _a === void 0 ? void 0 : _a.value) || '');
    }, [filters, filter]);
    var maxValue = useMemo(function () {
        var _a;
        return (((_a = filters.appliedFilters.find(function (f) { return f.queryKey === filter.queryName.split(',')[1]; })) === null || _a === void 0 ? void 0 : _a.value) || '');
    }, [filters, filter]);
    var handleMinChange = function (e) {
        var value = Number(e.target.value);
        var queryKey = filter.queryName.split(',')[0];
        if (value && !isNaN(value)) {
            setFilters(function (prevFilters) { return (__assign(__assign({}, prevFilters), { appliedFilters: __spreadArray(__spreadArray([], prevFilters.appliedFilters.filter(function (filter) { return filter.queryKey !== queryKey; }), true), [
                    {
                        queryKey: queryKey,
                        value: value,
                        label: "Min-Sal: ".concat(value, " PA"),
                    },
                ], false) })); });
        }
        else {
            setFilters(function (prevFilters) { return (__assign(__assign({}, prevFilters), { appliedFilters: __spreadArray([], prevFilters.appliedFilters.filter(function (f) { return f.queryKey !== queryKey; }), true) })); });
        }
    };
    var onBlur = function () {
        var _a, _b;
        var maxValue = (_a = filters.appliedFilters.find(function (f) { return f.queryKey === filter.queryName.split(',')[1]; })) === null || _a === void 0 ? void 0 : _a.value;
        var minValue = (_b = filters.appliedFilters.find(function (f) { return f.queryKey === filter.queryName.split(',')[0]; })) === null || _b === void 0 ? void 0 : _b.value;
        if (maxValue && minValue && minValue > maxValue) {
            setFilters(function (prevFilters) { return (__assign(__assign({}, prevFilters), { appliedFilters: __spreadArray([], prevFilters.appliedFilters.filter(function (f) { return f.queryKey !== filter.queryName.split(',')[1]; }), true) })); });
        }
    };
    var handleMaxChange = function (e) {
        var value = Number(e.target.value);
        var queryKey = filter.queryName.split(',')[1];
        if (!!value && !isNaN(value)) {
            setFilters(function (prevFilters) { return (__assign(__assign({}, prevFilters), { appliedFilters: __spreadArray(__spreadArray([], prevFilters.appliedFilters.filter(function (filter) { return filter.queryKey !== queryKey; }), true), [
                    {
                        queryKey: queryKey,
                        value: value,
                        label: "Max-Sal: ".concat(value, " PA"),
                    },
                ], false) })); });
        }
        else {
            setFilters(function (prevFilters) { return (__assign(__assign({}, prevFilters), { appliedFilters: __spreadArray([], prevFilters.appliedFilters.filter(function (f) { return f.queryKey !== queryKey; }), true) })); });
        }
    };
    return (_jsxs("div", { className: 'flex gap-4 pb-4', children: [_jsx(BaseInput, { type: 'number', placeholder: 'Min', className: '!outline-none bg-gray-200 !w-full !max-h-8 !rounded-md !p-2', value: minValue, onChange: handleMinChange, onBlur: onBlur }), _jsx(BaseInput, { type: 'number', placeholder: 'Max', className: '!outline-none bg-gray-200 !w-full !max-h-8 !rounded-md !p-2', value: maxValue, onChange: handleMaxChange, onBlur: onBlur })] }));
};
